
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanyTypeForm,
  CompanyTypeMergeRequest,
  CompanyTypeMergeResponse,
  CompanyTypesResponse,
  UpdateCompanyTypeAction,
  ValidationError,
} from '../models';
import {
    CompanyTypeFormFromJSON,
    CompanyTypeFormToJSON,
    CompanyTypeMergeRequestFromJSON,
    CompanyTypeMergeRequestToJSON,
    CompanyTypeMergeResponseFromJSON,
    CompanyTypeMergeResponseToJSON,
    CompanyTypesResponseFromJSON,
    CompanyTypesResponseToJSON,
    UpdateCompanyTypeActionFromJSON,
    UpdateCompanyTypeActionToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AddCompanyTypeRequest {
    countryCode: string;
    companyTypeForm: CompanyTypeForm;
}

export interface CompanyTypeRequest {
    countryCode: string;
}

export interface EnableCompanyTypeRequest {
    typeId: string;
    enable: boolean;
}

export interface MergeCompanyTypesRequest {
    companyTypeMergeRequest: CompanyTypeMergeRequest;
}

export interface UpdateCompanyTypeRequest {
    typeId: string;
    companyTypeForm: CompanyTypeForm;
    action?: UpdateCompanyTypeAction;
}

/**
 * 
 */
export class CompanyTypeAdminApi extends runtime.BaseAPI {

    /**
     * add a company type in a given country
          */
    async addCompanyTypeRaw(requestParameters: AddCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling addCompanyType().'
            );
        }

        if (requestParameters['companyTypeForm'] == null) {
            throw new runtime.RequiredError(
                'companyTypeForm',
                'Required parameter "companyTypeForm" was null or undefined when calling addCompanyType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{countryCode}`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyTypeFormToJSON(requestParameters['companyTypeForm']),
        }, initOverrides);

        return response;
    }

    /**
     * add a company type in a given country
          */
    async addCompanyType(requestParameters: AddCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.addCompanyTypeRaw(requestParameters, initOverrides);
    }

    /**
     * list of company types for a given country
          */
    async companyTypeRaw(requestParameters: CompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyTypesResponse>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling companyType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyTypesResponse>({
            path: `/compliance/api/admin/company/type/{countryCode}`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyTypesResponseFromJSON(response._data); }
        return response;
    }

    /**
     * list of company types for a given country
          */
    async companyType(requestParameters: CompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyTypesResponse> {
        const response = await this.companyTypeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * enable or disable a company type
          */
    async enableCompanyTypeRaw(requestParameters: EnableCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling enableCompanyType().'
            );
        }

        if (requestParameters['enable'] == null) {
            throw new runtime.RequiredError(
                'enable',
                'Required parameter "enable" was null or undefined when calling enableCompanyType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{typeId}/enable`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * enable or disable a company type
          */
    async enableCompanyType(requestParameters: EnableCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.enableCompanyTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Merge two company types - mark one as disabled and replace it with another.  The endpoint validates that the most important fields (userType, legalPersonType, country, language) are the same between the two company types before proceeding. Use force=true to skip these checks. 
          */
    async mergeCompanyTypesRaw(requestParameters: MergeCompanyTypesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyTypeMergeResponse>> {
        if (requestParameters['companyTypeMergeRequest'] == null) {
            throw new runtime.RequiredError(
                'companyTypeMergeRequest',
                'Required parameter "companyTypeMergeRequest" was null or undefined when calling mergeCompanyTypes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CompanyTypeMergeResponse>({
            path: `/compliance/api/admin/company/type/merge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyTypeMergeRequestToJSON(requestParameters['companyTypeMergeRequest']),
        }, initOverrides);

        if (response._data) { response._data=CompanyTypeMergeResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Merge two company types - mark one as disabled and replace it with another.  The endpoint validates that the most important fields (userType, legalPersonType, country, language) are the same between the two company types before proceeding. Use force=true to skip these checks. 
          */
    async mergeCompanyTypes(requestParameters: MergeCompanyTypesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyTypeMergeResponse> {
        const response = await this.mergeCompanyTypesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * update a company type
          */
    async updateCompanyTypeRaw(requestParameters: UpdateCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling updateCompanyType().'
            );
        }

        if (requestParameters['companyTypeForm'] == null) {
            throw new runtime.RequiredError(
                'companyTypeForm',
                'Required parameter "companyTypeForm" was null or undefined when calling updateCompanyType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{typeId}`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyTypeFormToJSON(requestParameters['companyTypeForm']),
        }, initOverrides);

        return response;
    }

    /**
     * update a company type
          */
    async updateCompanyType(requestParameters: UpdateCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCompanyTypeRaw(requestParameters, initOverrides);
    }

}
